import * as React from 'react';
import { SVGType } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IOfficeBuildingIconProps extends SVGType {}

export const OfficeBuildingIcon: React.FunctionComponent<IOfficeBuildingIconProps> = ({
  stroke = '#111928',
  size = 20,
  ...rest
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...rest}>
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0H5m14 0h2m-2 0h-5m-9 0H3m2 0h5m4 0v-5a1 1 0 00-1-1h-2a1 1 0 00-1 1v5m4 0h-4M9 7h1m-1 4h1m4-4h1m-1 4h1"
      ></path>
    </svg>
  );
};

export default OfficeBuildingIcon;
